import { store } from '../store'

export function setFocusToSidePanel() {
  let focusedComponent = store.getState('ui').focusedComponent

  if ('SidePanel' !== focusedComponent) {
    store.dispatch({
      type: 'OPEN_SIDE_PANEL',
    })
  }
}

export function registerFocusableComponent(component) {
  // Takes screen id { screen: this.state.id }
  store.dispatch({
    type: 'REGISTER_FOCUSABLE_COMPONENT',
    payload: component.screen,
  })
}

export function setFocusedComponent(componentToFocus) {
  store.dispatch({
    type: 'SET_FOCUS_COMPONENT',
    componentToFocus,
  })
}

export function setSidePanelVisibility(visible) {
  let currentVisibility = store.getState('ui')['side_panel_visible']

  if (currentVisibility !== visible) {
    store.dispatch({
      type: 'SET_SIDE_PANEL_VISIBILITY',
      visible,
    })
  }
}

export function setLoadingState(loading) {
  store.dispatch({
    type: 'LOADING_SCREEN',
    payload: { loadingScreen: loading },
  })
}
